var sourceUrl;
var documentWidth = $(document).width();
var datePickerMode = localStorage.getItem("datePickerMode") ? Number(localStorage.getItem("datePickerMode")) : 2;

$(document).on("change", ".js-trip-transport-type", function () {
  const isGroundTrip = $(this).attr("data-is-ground") === "true";
  const transportChanged = tripDataModel.isGroundTrip !== isGroundTrip;
  tripDataModel.isGroundTrip = isGroundTrip;

  window.tripSearchIsGround = tripDataModel.isGroundTrip;

  if (transportChanged) {
    ["origin", "destination"].forEach(function (type) {
      tripDataModel[type] = { id: "", tripTitle: "", cityTitle: "", citySlug: "", slug: "", countryTitle: "", countrySlug: "" };
    });

    updateTripTemplate();
  }

  $(".js-trip-transport-type").each(function () {
    const isGroundTrip = $(this).attr("data-is-ground") === "true";
    $(this).prop("checked", isGroundTrip === tripDataModel.isGroundTrip);
  });

  updateTripRailOptions();

  if (window.refreshTripSearchHistory) {
    window.refreshTripSearchHistory();
  }
});

$(document).on("change", ".js-trip-class-type", function () {
  tripDataModel.classType = Number($(this).val());

  updateTripRailOptions();
});

$(document).on("change", ".js-trip-is-exclusive", function () {
  tripDataModel.isExclusive = $(this).prop("checked");

  updateTripRailOptions();
});

function updateTripRailOptions() {
  $(".js-trip-rail-options").toggle(tripDataModel.isGroundTrip === true);

  $(".js-trip-options-rooms").toggleClass("trip-booking__rooms-options-rooms--rail", tripDataModel.isGroundTrip === true);

  $(".js-trip-class-options").each(function (index) {
    $(this).find(".js-trip-class-type").each(function () {
      $(this).attr("name", "trip-class-type-" + index);

      const id = "trip-class-" + index + "-" + $(this).val();

      $(this).attr("id", id).next("label").attr("for", id);

      $(this).prop("checked", Number($(this).val()) === (tripDataModel.classType || 3));
    });
  });

  $(".js-trip-is-exclusive").prop("checked", tripDataModel.isExclusive === true);

  $(".js-trip-is-exclusive").each(function (index) {
    const id = "trip-exclusive-" + index;

    $(this).attr("id", id).next("label").attr("for", id);
  });
}

if ($(".js-trip-card").length) {
  const clonedModal = createCloneTripModal(1);

  const modalWrapper = clonedModal.find(".js-trip-modal");

  $(".js-trip-card").click(function (event) {
    const selectedCity = $(event.target).attr("city-name")
      ? getTripDefaultLocations("destination").filter((city) => city.title === $(event.target).attr("city-name").trim())
      : [];

    if (selectedCity.length) {
      tripAutoSearch(modalWrapper.find(".js-trip-to-city"), "destination", selectedCity[0].title);
      tripDataModel["destination"].tripTitle = selectedCity[0].title;
      tripDataModel["destination"].id = selectedCity[0].id;
    }

    modalWrapper.addClass("show-modal");
    $("body").addClass("no-scroll");
  });
}

function createCloneTripModal(number) {
  const clone = $("#trip-tab").clone();
  clone.attr("id", "trip-modal");
  clone.addClass("active js-date-picker-not-scrollable");
  clone.find(".checkmark").each(function () {
    const name = $(this).attr("name");
    const id = $(this).attr("id");
    const target = $(this).attr("target");
    $(this).attr("name", `${name}-${number}`);
    $(this).attr("target", `${target}-${number}`);
    $(this).attr("id", `${id}-${number}`);
    $(this).next().attr("for", `${id}-${number}`);
    clone.find(`#${target}`).attr("id", `${target}-${number}`);
  });

  const $modal = $(
    `<div class='c-modal'>
      <div class="modal modal--black modal--flex fade js-trip-modal">
        <div class="container px--0">
          <div class="modal__content pb--0">
          <div class='c-booking-search'>
          <div class='booking-search js-booking-search'></div>
          </div>
          </div>
        </div>
      </div>
    </div>`
  );

  const modalWrapper = $modal.find(".js-trip-modal");
  $modal.find(".js-booking-search").append(clone);

  modalWrapper.click(function (event) {
    const target = $(event.target);
    if (target.hasClass(modalWrapper.attr("class"))) {
      modalWrapper.removeClass("show-modal");
      $("body").removeClass("no-scroll");

      tripAutoSearch($(this).find(".js-trip-to-city"), "destination", "");
      tripDataModel["destination"].tripTitle = "";
      tripDataModel["destination"].id = "";
    }
  });

  $("body").append($modal);

  return $modal;
}

$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  $(document).mouseup(function (e) {
    if (
      !$(".js-trip-rooms-options").is(e.target) && // if the target of the click isn't the container...
      $(".js-trip-rooms-options").has(e.target).length === 0
    ) {
      if ($(window).width() > 767) {
        // ... nor a descendant of the container
        $(".js-trip-rooms-options").removeClass("trip-booking__rooms-options--open");
      }
    }
  });

  tripDatePicker();
});

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

$(function () {
  //close autoComplete in mobile
  $(".js-trip-cities").delegate(".js-close-auto-complete", "click", function () {
    $(".js-close").closest(".focused").removeClass("focused");
    $(".js-mobile-layout").show();
    $("#js-trip-from-city").tripAutoComplete("close");
    $(".js-trip-to-city").tripAutoComplete("close");
    $("html").removeClass("no-scroll");
    $(".js-trip-search-input").removeClass("show-mobile");
  });
});

var tripList;

function tripinitializeSearch() {
  $(".js-trip-form #js-trip-from-city").each(function () {
    tripAutoSearch($(this), "origin");
  });

  $(".js-trip-form .js-trip-to-city").each(function () {
    tripAutoSearch($(this), "destination");
  });
}

function setInitialData() {
  if (typeof defaultOriginListOfGroundTrip == "undefined") {
    defaultOriginListOfGroundTrip = [];
  }

  if (typeof defaultDestinationListOfGroundTrip == "undefined") {
    defaultDestinationListOfGroundTrip = [];
  }

  if (typeof defaultOriginListOfTrip == "undefined") {
    defaultOriginListOfTrip = [];
  } else {
    defaultOriginListOfTrip = defaultOriginListOfTrip;
  }

  if (typeof defaultDestinationListOfTrip == "undefined") {
    defaultDestinationListOfTrip = [];
  } else {
    defaultDestinationListOfTrip = defaultDestinationListOfTrip;
  }
}

function getTripDefaultLocations(inputType) {
  setInitialData();

  if (tripDataModel.isGroundTrip) {
    return inputType === "origin" ? defaultOriginListOfGroundTrip : defaultDestinationListOfGroundTrip;
  }

  return inputType === "origin" ? defaultOriginListOfTrip : defaultDestinationListOfTrip;
}

//autoComplete
function tripSearch() {
  $(".js-booking-section").each(function () {
    if ($(this).hasClass("active")) {
      setInitialData();
      tripinitializeSearch();
    }
  });

  $(".js-tab-nav .js-tab-nav-header button").on("click", function () {
    setTimeout(function () {
      setInitialData();
      tripinitializeSearch();
    }, 0);
  });
  tripinitializeSearch();
}

$.widget("custom.tripAutoComplete", $.ui.autocomplete, {
  _renderMenu: function (ul, items) {
    var that = this;
    $.each(items, function (index, item) {
      if (Object.keys(item).length) {
        that._renderItemData(ul, item);
      }
    });
  },
  _renderItem: function (ul, item) {
    var li = "";
    if (Object.keys(item).length) {
      var className = item.destinationType === 2 ? "rtl" : "ltr";

      ul.removeClass("rtl ltr");

      ul.addClass(className);

      var icon = item.locationType === 1 ? "icon-map " : "icon-bed";

      var location;

      if (item.destinationType === 1) {
        location =
          item.locationType === 1
            ? `<span>${item.countryTitle}</span>`
            : `<span>${item.countryTitle + " , " + item.cityTitle}</span>`;
      } else {
        location = item.locationType === 2 ? `<span>${item.cityTitle}</span>` : null;
      }
      li += "<li>" + '<span class="item-wrapper">' + "<i class='" + icon + "'>" + "</i>" + item.value + "</span>";

      if (location) {
        li += location;
      }

      li += "</li>";
    }

    return $(li).appendTo(ul);
  },
});

// trip auto search
function tripAutoSearch($this, inputType, initValue = null) {
  $this
    .tripAutoComplete({
      minLength: 0,
      appendTo: $this.next(".js-trip-search-list"),
      delay: 600,
      search: function () {
        $(this).closest(".js-trip-search-input").addClass("show-mobile");
        if (documentWidth < 992) {
          $("html").addClass("no-scroll");
        }
      },
      source: function (request, response) {
        if ($this.val() && tripList !== null) {
          $this.parent().find(".js-search-loading").show();
          $.ajax({
            url: "/hotelbooking-api/searchtitle/" + request.term + "/?demandtype=1",
            dataType: "json",
            success: function (data) {
              //trip
              $this.parent().find(".js-search-loading").hide();
              response(
                $.map(data.model, function (obj) {
                  return {
                    value: obj.title,
                    tripTitle: obj.title,
                    slug: obj.slug,
                    cityTitle: obj.cityTitle,
                    citySlug: obj.citySlug,
                    countrySlug: obj.countrySlug,
                    countryTitle: obj.countryTitle,
                    locationType: obj.locationType,
                    destinationType: obj.destinationType,
                    id: obj.id,
                    isRtl: obj.isRtl,
                    dir: obj.dir,
                  };
                })
              );
            },
            error: function () {
              $this.parent().find(".js-search-loading").hide();
            },
          });
        } else {
          return response(getTripDefaultLocations(inputType));
        }
      },
      open: function () {
        $this.addClass("focusedInput");
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");

        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $this.attr("autocomplete", "off");
        }

        var inputObj = $(this);
        inputObj
          .next(".js-trip-search-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });

        $this.parent().find(".js-trip-search-list").show();

        // $(".js-trip-search-input").addClass("show-mobile");
      },
      close: function () {
        $this.removeClass("focusedInput");

        if ($("html").hasClass("no-scroll")) {
          $("html").removeClass("no-scroll");
        }
      },
      select: function (e, ui) {
        tripDataModel[inputType].tripTitle = ui.item.value;

        tripDataModel[inputType].slug = ui.item.slug;

        tripDataModel[inputType].cityTitle = ui.item.cityTitle;

        tripDataModel[inputType].citySlug = ui.item.citySlug;

        tripDataModel[inputType].countryTitle = ui.item.countryTitle;

        tripDataModel[inputType].countrySlug = ui.item.countrySlug;

        tripDataModel[inputType].id = ui.item.id;
        tripDataModel[inputType].dir = ui.item.dir;

        tripDataModel.locationType = ui.item.locationType;

        tripDataModel.destinationType = ui.item.destinationType;

        /////////////

        $this.removeClass("empty");
        $this.closest(".js-trip-search-input").addClass(ui.item.dir);

        $this.attr("data-value", ui.item.value);

        $this.parent().find(".error-message").remove();
        $this.removeClass("notValid");

        $this.parent().find(".js-search-loading").hide();

        $this.siblings(".js-trip-input-layout").html("<span>" + ui.item.value + "</span>");

        $(this).closest(".js-trip-search-input").removeClass("show-mobile");
        $("html").removeClass("no-scroll");

        if (documentWidth <= 992) {
          $this.attr("placeholder", ui.item.value);
          $this
            .closest(".js-trip-form")
            .find(".js-trip-input-layout")
            .html("<span>" + ui.item.value + "</span>");
          $this.parent().find(".js-search-loading").hide();
        }

        if ($this.is(".js-trip-from-city")) {
          $this.closest(".js-trip-cities").find(".js-trip-to-city").tripAutoComplete("search");

          let timeOut = setTimeout(() => {
            $this.closest(".js-trip-cities").find(".js-trip-to-city").trigger("focus");
            clearTimeout(timeOut);
          }, 0);
        } else if ($(this).is(".js-trip-to-city")) {
          $(this).closest(".js-trip-form").find(".js-trip-check-in-date").datepicker("show");
          setTimeout(function () {
            document.activeElement.blur();
          }, 0);
        }

        $(this).parent().find(".error-message").remove();

        tagManager({ value: ui.item.value, type: searchType });
      },
    })
    .bind("focus", function () {
      if ($(window).width() > 992 || $(".js-trip-search-input").hasClass("show-mobile")) {
        $(this).val("");
        $(this).tripAutoComplete("search");
      }

      $this.parent().find(".js-search-loading").hide();
    })
    .bind("blur", function () {
      $this.parent().find(".js-search-loading").hide();
      if ($this.attr("id") == "js-trip-from-city") {
        $this.attr("placeholder", "مبدا");
      } else {
        $this.attr("placeholder", "مقصد");
      }

      if (!$(this).hasClass("empty")) $(this).val($(this).attr("data-value"));
    });

  if (initValue != null) {
    $this.val(initValue).data("autocomplete");
  }
}

$("body").delegate(".js-trip-input-layout", "click", function () {
  $(this).closest(".js-trip-search-input").addClass("show-mobile");

  $(this).next().trigger("focus");

  $("#js-trip-from-city").tripAutoComplete("search");
});

function roomsDetailToggled() {
  $(".js-trip-rooms-toggle").toggleClass("trip-booking__rooms-options--open");
  if (documentWidth < 992) {
    $("html").addClass("no-scroll");
  }
  tripcheckAlignBox();
}

$("body").delegate(".js-trip-rooms-toggle", "click", function () {
  roomsDetailToggled();
});

//toggle room detail
// $("body").delegate(".js-trip-rooms-toggle", "click", function () {
//   $(this).toggleClass("trip-booking__rooms-options--open");
//   if (documentWidth < 992) {
//     $("html").addClass("no-scroll");
//   }
//   tripcheckAlignBox();
// });

//room close
$("body").delegate(".js-room-trip-close, .js-trip-rooms-confirm", "click", function () {
  $(".js-trip-rooms-toggle").removeClass("trip-booking__rooms-options--open");
  if ($("html").hasClass("no-scroll")) {
    $("html").removeClass("no-scroll");
  }
});

//check form validation
function tripCheckValidation(target) {
  var valid = true;
  let fillFieldValid = !(
    tripDataModel["origin"].tripTitle === "" ||
    tripDataModel["destination"].tripTitle === "" ||
    $(target).closest(".js-booking-section.active").find('input[name="trip-city"]').val() === "" ||
    tripDataModel.tripStartDateEn === "" ||
    tripDataModel.tripEndDateEn === ""
  );
  let routeValid = tripDataModel.origin?.slug?.trim()?.toLowerCase() !== tripDataModel.destination.slug?.trim()?.toLowerCase();

  $(target).closest(".js-booking-section.active").find(".js-trip-form .error-message").remove();
  // tripUpdateDates();

  if (!fillFieldValid || !routeValid) {
    $(target)
      .closest(".js-booking-section.active")
      .find(".js-trip-form")
      .append(
        `<span class="error-message">${
          !fillFieldValid ? "لطفا تمام فیلدها را کامل نمایید" : "مبدا و مقصد نمی تواند یکسان باشد"
        }</span>`
      );
    valid = false;
  }

  var startDate = moment(
    $(target).closest(".js-booking-section.active").find('input[name="tripStartDate"]').next().val()
  );

  var endDate = moment($(target).closest(".js-booking-section.active").find('input[name="tripEndDate"]').next().val());

  var dateDifference = endDate.diff(startDate, "days");

  if (dateDifference > 20) {
    $(target)
      .closest(".js-booking-section.active")
      .find(".js-trip-form .js-trip-booking-date")
      .append('<span class="error-message">بازه تاریخ ورود و برگشت نباید بیشتر از 20 روز باشد.</span>');

    valid = false;
  }

  if (
    tripDataModel.rooms.flatMap((element) => element.childs).includes(0)
  ) {
    $(target)
      .closest(".js-booking-section.active")
      .find(".js-trip-rooms")
      .append(
        `<span class="error-message error-message--child">لطفا فیلد سن کودک را پر کنید را پر کنید</span>`
      );
    valid = false;
  }

  if (valid) valid = flightPassengerLimit(purificationPassengers(), target);

  return valid;
}

function purificationPassengers() {
  return tripDataModel.rooms.reduce(
    (passengers, room) => {
      passengers.adult += room.adult;
      room.childs.forEach(age => {
        age > 3 ? passengers.child++ : passengers.baby++;
      });
      return passengers;
    },
    { adult: 0, child: 0, baby: 0 }
  );
}

function flightPassengerLimit({ adult, child, baby }, target) {
  // target: HTMLElement, adult: number, child: number, baby: number
  let valid = true;
  let msg = ''
  if (+adult + +child > 9) {
    msg = 'تعداد مسافران غیر از نوزاد بیشتر از ۹ نفر نباید باشد'
    valid = false;
  } else if (+baby > +adult) {
    msg = 'نوزادان همیشه با والدین یا سرپرستان خود سفر میکنند (هر بزرگسال یک کودک)'
    valid = false;
  }

  if (!valid) {
    if($(window).width() > 767) {
      $(target)
        .closest(".js-booking-section.active")
        .find(".js-trip-options-rooms")
        .append(
          `<span class="error-message">${msg}</span>`
        );

      $(target)
        .closest(".js-booking-section.active")
        .find(".js-trip-form .js-trip-rooms")
        .append(`<span class="error-message">مسافران انتخابی صحیح نیست</span>`);

    if (!$(".js-trip-rooms-toggle").hasClass("trip-booking__rooms-options--open")) roomsDetailToggled();
    }
    else {
      $(target)
        .closest(".js-booking-section.active")
        .find(".js-trip-form .js-trip-rooms")
        .append(`<span class="error-message">${msg}</span>`);

    }
  }

  return valid;
}

//search event
$("body").delegate(".js-trip-search", "click", function (e) {
  e.stopPropagation();
  let isInModal = Boolean(this.closest(".js-trip-modal"));

  var adultsString = "",
    childString = "",
    childAgeString = "";
    
    $.each(tripDataModel.rooms, function (i, room) {
      adultsString += "&a=" + room.adult;
      
      childString += "&c=" + room.child;
      
      $.each(room.childs, function (j, child) {
        childAgeString += "&g=" + Number(child - 1);
      });
    });

  var url = "/trip/";

  var valid = tripCheckValidation(e.target);

  if (!valid) {
    return;
  }

  url +=
    "?i=" +
    tripDataModel.tripStartDateEn +
    "&o=" +
    tripDataModel.tripEndDateEn +
    "&r=" +
    tripDataModel.roomsCount +
    "&n=" +
    "&d=" +
    tripDataModel.destination.id +
    "&or=" +
    tripDataModel.origin.id +
    adultsString +
    childString +
    childAgeString +
    "&isGroundTrip=" +
    tripDataModel.isGroundTrip;

  if (tripDataModel.isGroundTrip) {
    url += "&classType=" + (tripDataModel.classType || 3) + "&isExclusive=" + (tripDataModel.isExclusive === true);
  }

  var localStorageKey = `${window.prefixSearchHistory}-${tripDataModel.isGroundTrip ? "rail" : "online"}-${
    isInModal ? "trip-tab" : ($(".js-search-holder-landing").attr("id") || $(".js-tab-nav").find(".js-tab-content>div.active").attr("id"))
  }`;

  window.updateLocalStorage(localStorageKey, {
      value: { ...tripDataModel, tourType: tripDataModel.isGroundTrip ? "rail" : "online" },
      baseUrl: url,
      expire: tripDataModel.tripStartDateEn,
    });

  window.location.assign(url);
});

// trip booking

//static data
tripAdultCountArray = [
  "1 بزرگسال",
  "2 بزرگسال",
  "3 بزرگسال",
  "4 بزرگسال",
  "5 بزرگسال",
  "6 بزرگسال",
  "7 بزرگسال",
  "8 بزرگسال",
  "9 بزرگسال",
];
tripChildCountArray = ["0 کودک", "1 کودک", "2 کودک", "3 کودک", "4 کودک"];
tripChildAgesArray = [
  "0 - 1 (نوزاد)",
  "1 - 2 (نوزاد)",
  "2 - 3 ",
  "3 - 4 ",
  "4 - 5 ",
  "5 - 6 ",
  "6 - 7 ",
  "7 - 8 ",
  "8 - 9 ",
  "9 - 10 ",
  "10 - 11 ",
  "11 - 12 ",
];

var tripDataModel = {
  isGroundTrip: false,
  classType: 3,
  isExclusive: false,
  tripEndDate: "",
  tripEndDateEn: "",
  tripStartDate: "",
  tripStartDateEn: "",
  locationType: 1,
  daysDuration: null,
  roomsCount: 1,
  childLabels: [],
  dir: "rtl",
  childsCount: 0,
  adultsCount: 0,
  destination: {
    tripTitle: "",
    cityTitle: "",
    citySlug: "",
    slug: "",
    countryTitle: "",
    countrySlug: "",
  },
  origin: {
    tripTitle: "",
    cityTitle: "",
    citySlug: "",
    slug: "",
    countryTitle: "",
    countrySlug: "",
  },
  rooms: [
    {
      room: 1,
      adult: 2,
      child: 0,
      childs: [],
    },
  ],
};

var tripInput = [];

//add or remove room
var roomNum;
$("body").delegate(".js-trip-form .js-trip-count-box button", "click", function () {
  if ($(this).hasClass("js-trip-max")) {
    if (tripDataModel.roomsCount < 4) {
      roomNum = tripDataModel.roomsCount + 1;

      tripDataModel.roomsCount = roomNum;

      tripDataModel.rooms.push({
        room: roomNum,
        adult: 1,
        child: 0,
        childs: [],
      });
    }
  } else if ($(this).hasClass("js-trip-min")) {
    if (tripDataModel.roomsCount > 1) {
      roomNum = tripDataModel.roomsCount - 1;

      tripDataModel.roomsCount = roomNum;

      tripDataModel.rooms.pop();
    }
  }
  updateTripTemplate(tripDataModel);
});

// select adult count
$("body").delegate("select.js-trip-rooms-adult-count", "change", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  tripDataModel.rooms[roomIndex].adult = Number($(this).val()) + 1;

  updateTripTemplate(tripDataModel);
});

//in mobile
$("body").delegate(".js-trip-adults>button", "click", function (e) {
  e.preventDefault();
  var roomIndex = $(this).closest("ul").attr("data-row");

  var roomNumber = $(this).hasClass("js-trip-add")
    ? Number($(this).siblings("input").val()) + 1
    : Number($(this).siblings("input").val()) - 1;

  $(this).siblings("input").val(roomNumber);

  tripDataModel.rooms[roomIndex].adult = Number(roomNumber);

  updateTripTemplate(tripDataModel);
});

//select child count
$("body").delegate("select.js-trip-rooms-child-count", "change", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  tripDataModel.rooms[roomIndex].child = Number($(this).val());

  var oldChildCount = tripDataModel.rooms[roomIndex].childs.length;

  var selectedChildCount = Number($(this).val());

  if (selectedChildCount === oldChildCount) return;

  var newChildCount = 0;

  if (selectedChildCount > oldChildCount) {
    newChildCount = selectedChildCount - oldChildCount;
    for (i = 0; i < newChildCount; i++) {
      tripDataModel.rooms[roomIndex].childs.push(0);
    }
  } else {
    newChildCount = oldChildCount - selectedChildCount;
    for (i = 0; i < newChildCount; i++) {
      tripDataModel.rooms[roomIndex].childs.pop();
    }
  }
  updateTripTemplate(tripDataModel);
});

////select child count In mobile
$("body").delegate(".js-trip-childs-count-InMobile>button", "click", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  var selectedChildCount = $(this).hasClass("js-trip-add")
    ? Number($(this).siblings("input").val()) + 1
    : Number($(this).siblings("input").val()) - 1;

  if (selectedChildCount > 4 || selectedChildCount < 0) return;

  $(this).siblings("input").val(selectedChildCount);

  tripDataModel.rooms[roomIndex].child = selectedChildCount;

  var oldChildCount = tripDataModel.rooms[roomIndex].childs.length;

  // var selectedChildCount = Number($(this).val());

  if (selectedChildCount === oldChildCount) return;

  var newChildCount = 0;

  if (selectedChildCount > oldChildCount) {
    newChildCount = selectedChildCount - oldChildCount;
    for (i = 0; i < newChildCount; i++) {
      tripDataModel.rooms[roomIndex].childs.push(0);
    }
  } else {
    newChildCount = oldChildCount - selectedChildCount;
    for (i = 0; i < newChildCount; i++) {
      tripDataModel.rooms[roomIndex].childs.pop();
    }
  }
  updateTripTemplate(tripDataModel);
});

//select childs Age
$("body").delegate("select.js-trip-child-age", "change", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  var childAgeIndex = Number($(this).attr("name"));

  var childAge = Number($(this).val()) + 1;

  tripDataModel.rooms[roomIndex].childs[childAgeIndex] = childAge;

  updateTripTemplate(tripDataModel);
});

////////////////////////////
$("body").delegate(".js-trip-room-remove", "click", function () {
  var roomIndex = $(this).closest("ul").attr("data-row");

  tripDataModel.rooms.splice(Number(roomIndex), 1);
  tripDataModel.roomsCount = tripDataModel.roomsCount - 1;
  updateTripTemplate();
});

//update Data
function tripUpdateDates(target) {
  tripDataModel.tripStartDateEn = $(target)
    .closest(".js-booking-section.active")
    .find(".js-trip-form .js-trip-check-in-date")
    .next()
    .val();

  tripDataModel.tripEndDateEn = $(target)
    .closest(".js-booking-section.active")
    .find(".js-trip-form .js-trip-check-out-date")
    .next()
    .val();

  tripDataModel.tripStartDate = $(target)
    .closest(".js-booking-section.active")
    .find(".js-trip-form .js-trip-check-in-date")
    .val();

  tripDataModel.tripEndDate = $(target)
    .closest(".js-booking-section.active")
    .find(".js-trip-form .js-trip-check-out-date")
    .val();
}

//update Template
function updateTripTemplate(newTemplate) {
  //get adultCount
  tripDataModel.adultsCount = 0;
  tripDataModel.childsCount = 0;
  $.each(tripDataModel.rooms, function (key, room) {
    tripDataModel.adultsCount += room.adult;
    tripDataModel.childsCount += room.child;
  });
  //check if rooms menu is open after update open it
  var flag = false;
  if ($(".js-trip-rooms-toggle").hasClass("trip-booking__rooms-options--open")) {
    flag = true;
  }
  var labelsArray = tripcountLabelNumbers(tripDataModel.rooms);
  tripDataModel.childLabels = labelsArray;

  $(".js-trip").html($("#js-trip-template").tmpl(tripDataModel));

  updateTripRailOptions();

  if (flag) {
    $(".js-trip-rooms-toggle").addClass("trip-booking__rooms-options--open");
  }
  tripcheckAlignBox();
  tripSearch();
  tripDatePicker();
}
//check align of rooms details menu
function tripcheckAlignBox() {
  if (
    $(".js-trip-form").offset().left > $(".js-trip-options-rooms").offset().left &&
    $(".rooms-toggleBtn").hasClass("trip-booking__rooms-options--open")
  ) {
    $(".js-trip-rooms-options").addClass("align-left");
  } else {
    $(".js-trip-rooms-options").removeClass("align-left");
  }
}

function tripcountLabelNumbers(rooms) {
  var childsLabel = ["بزرگسال", "کودک"];
  var max = 0;
  for (var i = 0; i < rooms.length; i++) {
    if (rooms[i].childs.length > max) {
      max = rooms[i].childs.length;
    }
  }
  for (var j = 0; j < max; j++) {
    childsLabel.push("سن کودک  " + (j + 1));
  }
  return childsLabel;
}

//check diff
function tripCalcDiffDate() {
  if (!tripDataModel.tripStartDateEn || !tripDataModel.tripEndDateEn) {
    return "";
  }
  var startDate = moment.utc(tripDataModel.tripStartDateEn);
  var endDate = moment.utc(tripDataModel.tripEndDateEn);
  var daysDuration = endDate.diff(startDate, "days");
  return daysDuration;
}

function tripDatePicker() {
  setTimeout(function () {
    $(".js-trip-form .js-trip-booking-date").pickDate({
      // dateFormat: "dd MM yy",
      // dateFormatEn: "yy M dd",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      isDependenceDates: false,
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      customClass: "lightTheme",
      showAllMonthsinList: false,
      langType: datePickerMode === 1 ? '':'fa',
      blurInmobile: true,
      dayNamesShortFa: ["1شنبه", "2شنبه", "3شنبه", "4شنبه", "5شنبه", "جمعه", "شنبه"],
      enterDateTitle: "تاریخ ورود",
      exitDateTitle: "تاریخ خروج",
      enterDateTitleEn: "Check in",
      exitDateTitleEn: "Check out",
      dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
      onSelectEvent: function () {
        if ($(this).hasClass("pickDate_2")) {
          var daysDurationParam = tripCalcDiffDate();
          tripDataModel.daysDuration = daysDurationParam;
          if (tripDataModel.daysDuration) {
            $(this)
              .closest(".js-booking-section.active")
              .find(".js-trip-booking-night-count")
              .html("<i class='icon-moon'></i>" + tripDataModel.daysDuration)
              .addClass("night-count-show");
          }
        } else {
          tripDataModel.daysDuration = null;
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-trip-booking-night-count")
            .removeClass("night-count-show");
        }

        tripUpdateDates($(this));
      },
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
    });
  }, 100);
}

updateTripTemplate();

$("body").on("click", function (e) {
  if (!$(e.target).closest(".js-trip-rooms-options").length) {
    if ($(".js-trip-rooms-toggle").hasClass("trip-booking__rooms-options--open")) {
      $(".js-trip-rooms-toggle").removeClass("trip-booking__rooms-options--open");
    }
  }
});
